import { AfterViewInit, Component, OnInit } from '@angular/core';
import { UntypedFormBuilder, UntypedFormGroup, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { faEyeSlash } from '@fortawesome/free-solid-svg-icons';
import { faEye, faPhoneVolume } from '@fortawesome/free-solid-svg-icons';
import { AuthService } from '../auth.service';
import { safeReturnPath } from '../safe-return-path';
declare const gapi: any;
declare global {
  interface Window {
    onGoogleSignIn: (response: any) => void;
  }
}
@Component({
    selector: 'app-login',
    templateUrl: './login.component.html',
    styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit, AfterViewInit {
     private auth2: any;
     client_id: '461257392234-393ocvv5jdr3b2cq4m5unlprjv247jdr.apps.googleusercontent.com'
    email: string;
    returnUrl = '';
    password: string;
    errorMessage: string;
    loading: boolean;
    passwordVisible: boolean = false;
    faPhoneVolume = faPhoneVolume;
    faEye = faEye;
    faEyeSlash = faEyeSlash;
    loginForm: UntypedFormGroup;
    constructor(
        private authService: AuthService,
        private router: Router,
        private activatedRoute: ActivatedRoute,
        private fb: UntypedFormBuilder
    ) {}

    ngOnInit(): void {
        this.loading = false;
        this.returnUrl = safeReturnPath(this.activatedRoute.snapshot.queryParams.returnUrl, '');
        this.loginForm = this.fb.group({
            email: [this.activatedRoute.snapshot.queryParams.email
                ? this.activatedRoute.snapshot.queryParams.email
                : '', [Validators.email, Validators.required]],
            password: ['', Validators.required]
        })
        // this.email = this.activatedRoute.snapshot.queryParams.email
        //     ? this.activatedRoute.snapshot.queryParams.email
        //     : '';
    }



      ngAfterViewInit(): void {
        window.onGoogleSignIn= this.onGoogleSignIn.bind(this);
  }

    onGoogleSignIn(res: any) {
    console.log(res);

  }


    async login() {
        this.loading = true;
        const redirect = this.returnUrl;
        this.authService
            .login(this.loginForm.controls['email'].value.toLowerCase(), this.loginForm.controls['password'].value)
            .then((user) => {
                if (redirect) {
                    this.router.navigateByUrl(redirect);
                } else {
                    if (user.get('role') && user.get('role') === 'admin') {
                      this.router.navigate(['admin', 'dashboard']);
                    } else {
                        this.router.navigate(['user']);
                    }
                }
                this.loading = false;
            })
            .catch((err) => {
                this.loading = false;
                this.errorMessage = err;
            });
    }

    togglePassword(show) {
        this.passwordVisible = show;
    }

    handleCredentialResponse(e?: any){
        console.log(e)
    }


}
